export default "__VITE_PUBLIC_ASSET__a9b62635__"